import "core-js/modules/es.array.find-index.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import useStore from '@/store';
import { ElScrollbar } from 'element-plus';
import 'element-plus/es/components/scrollbar/style/css'


import { computed, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollPane',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var store = useStore();
    var visitedViews = computed(function () {
      return store.tagsView.visitedViews;
    });
    var scrollWidth = computed(function () {
      return store.app.sidebar.opened ? 'calc(100vw - 64px)' : 'calc(100vw - 200px)';
    });
    var scrollContainer = ref();
    function moveToTarget(currentTag) {
      var index = visitedViews.value.findIndex(function (tag) {
        return tag.path === currentTag.path;
      });
      if (index > -1) {
        var _scrollContainer$valu;
        var el = (_scrollContainer$valu = scrollContainer.value) === null || _scrollContainer$valu === void 0 ? void 0 : _scrollContainer$valu.$el;
        var scrollBarView = el && el.getElementsByClassName('el-scrollbar__view')[0].children;
        if (scrollBarView.length > index) {
          var _scrollContainer$valu2;
          (_scrollContainer$valu2 = scrollContainer.value) === null || _scrollContainer$valu2 === void 0 || _scrollContainer$valu2.scrollTo({
            left: scrollBarView[index].offsetLeft,
            behavior: "smooth"
          });
        }
      }
    }
    __expose({
      moveToTarget: moveToTarget
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_unref(ElScrollbar), {
        ref_key: "scrollContainer",
        ref: scrollContainer,
        vertical: false,
        always: "",
        style: _normalizeStyle({
          width: _unref(scrollWidth)
        }),
        class: "scroll-container"
      }, {
        default: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        }),
        _: 3
      }, 8, ["style"]);
    };
  }
});